module.exports = __webpack_public_path__ + "img/item15.377a258e.png";